import { useMemo } from "react";

import {
  EditGLDStartRegistrationTask,
  GLDStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GldStartRegistrationFormProps } from "@/types/form-types";

import { useGldUiSchema } from "../../schema/gld-ui-schema";

import { getGldStartRegistrationSchema } from "./schema/gld-start-registration-schema";

export function GldStartRegistrationForm(props: GldStartRegistrationFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    GLDStartRegistrationTask | EditGLDStartRegistrationTask
  >({ key: "gld", task });

  const uiSchema = useGldUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(
    () => getGldStartRegistrationSchema({ type, isEditing }),
    [type, isEditing]
  );

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editGldStartRegistration(formData);
    } else {
      await api.createGldStartRegistration(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
